import fetch from 'node-fetch';
import { isLLc } from './utils';
import { PAYPAL_INIT } from '../constants/constants';

const generateInitUrl = (orderId, fromPage, itemCount, ffm) => {
  const urlDomain = !isLLc() ? 'https://www.homedepot.com' : 'https://hd-qa74.homedepotdev.com';
  // mcc-checkout will set paypal express as true if fromPage is shoppingCart or addToCart
  // for any other values it will be set as false.
  const urlParams = '?fromPage=' + fromPage
    + '&orderId=' + orderId
    + '&itemType=' + ffm
    + '&itemCount=' + itemCount
    // These dont seem to do anything in mcc-checkout
    + '&myCart=true&opc=true';
  return urlDomain + PAYPAL_INIT + urlParams;
};

export const fetchPaypalToken = (orderId, fromPage, itemCount, ffm) => {
  const options = {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'include',
  };

  const req = new fetch.Request(generateInitUrl(orderId, fromPage, itemCount, ffm), options);
  return req;
};
